export const DocumentCaptureSessionTestIds = {
  DRAWER: 'capture-session.drawer',
  CLOSE: 'capture-session.close-button',
  ADD_MORE: 'capture-session.add-more-button',
  BATCH_LABEL: 'capture-session.batch-label-input',
  ADD_SOURCE: 'capture-session.add-source-button',
  FILE_INPUT: 'capture-session.file-input',
  CONTINUE: 'capture-session.continue-button',
};
